// frontend/src/router/index.js
import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "../stores/authStore";
import Calendar from "../views/Calendar.vue";

const routes = [
  {
    path: "/",
    name: "Calendar",
    component: Calendar,
    meta: { requiresAuth: true },
  },
  {
    path: "/staff",
    name: "Staff",
    component: () => import("../views/Staff.vue"),
    meta: { requiresAuth: true, adminOnly: true },
  },
  {
    path: "/timeoff",
    name: "TimeOff",
    component: () => import("../views/TimeOff.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
    meta: { guest: true },
  },
  {
    path: "/admin-tools",
    name: "AdminTools",
    component: () => import("../views/AdminTools.vue"),
    meta: { requiresAuth: true, adminOnly: true },
  },
  {
    path: "/stores",
    name: "Stores",
    component: () => import("../views/Stores.vue"),
    meta: { requiresAuth: true, adminOnly: true },
  },
  {
    path: "/holiday-hours",
    name: "HolidayHours",
    component: () => import("../views/HolidayHours.vue"),
    meta: { requiresAuth: true, adminOnly: true },
  },
  {
    path: "/home",
    redirect: "/",
  },
  // 404 catch-all route
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("../views/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const adminOnly = to.matched.some((record) => record.meta.adminOnly);
  const guestOnly = to.matched.some((record) => record.meta.guest);

  if (!authStore.isAuthenticated) {
    try {
      await authStore.initializeAuth();
    } catch (error) {
      console.error("Auth initialization failed:", error);
    }
  }

  // Check authorization
  if (requiresAuth && !authStore.isAuthenticated) {
    next({ name: "Login" });
  } else if (adminOnly && !authStore.isAdmin) {
    next({ name: "Calendar" });
  } else if (guestOnly && authStore.isAuthenticated) {
    next({ name: "Calendar" });
  } else {
    next();
  }
});

export default router;
